module.exports = __webpack_public_path__ + "assets/img/img313.49122c88.png";